export const NAV_LABELS = {
  protectionCoverage: 'Protection Coverage',
  securityActivity: 'Security Activity',
  evidenceExport: 'Evidence Export',
  adminAccessRules: 'Admin Access Location Rules',
};

export const STATUS_LABELS = {
  covered: 'Covered',
  partial: 'Partially covered',
  actionRequired: 'Action required',
  monitoringPlanned: 'Monitoring planned',
};

export const STATUS_DESCRIPTIONS = {
  covered: 'Protections are active and monitoring is healthy.',
  partial: 'Some protections are monitoring-only or need action to fully enforce.',
  actionRequired: 'Action is required to address a critical coverage gap.',
  monitoringPlanned: 'Checks have not reported yet for this area.',
};

export const FRAMEWORK_DISCLOSURE_COPY =
  'These controls are aligned to security best practices. This is not a compliance certification.';

export const OWASP_MAPPING_LABELS = {
  technicalHeading: 'Framework mapping (technical)',
  internalOnly: 'Aligned frameworks: OWASP Top 10 (mapping only)',
};

export type CoverageBadge = 'covered' | 'partial' | 'action' | 'planned';

export const normalizeSecurityStatus = (input: {
  status?: string | null;
  severity?: string | null;
  enforced?: boolean | null;
  hasSignals?: boolean | null;
}): { badge: CoverageBadge; text: string; tone: 'good' | 'warn' | 'bad' } => {
  const raw = `${input.status || ''}`.toLowerCase();
  const severity = `${input.severity || ''}`.toLowerCase();
  const hasSignals = input.hasSignals !== false;

  if (!hasSignals || raw === 'planned' || raw === 'not_implemented' || raw === 'monitoring_planned') {
    return { badge: 'planned', text: STATUS_LABELS.monitoringPlanned, tone: 'warn' };
  }

  if (raw === 'critical' || raw === 'high_risk' || severity === 'critical' || severity === 'high') {
    return { badge: 'action', text: STATUS_LABELS.actionRequired, tone: 'bad' };
  }

  if (raw === 'warn' || raw === 'degraded' || severity === 'warn' || severity === 'medium') {
    return { badge: 'partial', text: STATUS_LABELS.partial, tone: 'warn' };
  }

  if (raw === 'ok' || raw === 'healthy' || raw === 'resolved' || raw === 'good' || input.enforced) {
    return { badge: 'covered', text: STATUS_LABELS.covered, tone: 'good' };
  }

  return { badge: 'partial', text: STATUS_LABELS.partial, tone: 'warn' };
};
